/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import CardHeader from '../../../components/CardHeader'
import TopBarWithShadow from '../../../components/TopBar/TopBarWithShadow'
import SidePopup from './Component/SidePopup'
import React, { useEffect, useState, useCallback, useContext } from 'react';
import Pagination from '../../../components/Pagination';
import 'tw-elements';
import { useLocation, useSearchParams } from 'react-router-dom';
import ItemShimmer from '../../../components/Shimmer/itemShimmer';
import SearchEmptyScreen from '../../../components/SearchEmptyScreen';
import { useDispatch, useSelector } from 'react-redux';
import {PayrollData} from './PayrollSlice'
import { GetBranchId } from '../../../CommonMethods/GetBranchId';
import Table from './Component/Table';
import Toast from '../../../components/Toast';
import { dataService } from '../../../services/data.services';
import EmptyAddScreenButton from '../../../components/EmptyAddScreenButton'
import GlobalContext from '../../../components/Context/GloablContext';

export default function Payroll() {
    const [isSidePopup, setIsSidePopup] = useState(false)
    const [toastErrorMessage, setToastErrorMessage] = useState('')
    const dispatch = useDispatch();
    const PayrollList = useSelector(state => state.payrollSlice);
    const { List } = PayrollList
    const [loading, setLoading] = useState(true);
    const location = useLocation();
    const [confirmationState, setConfirmationState] = useState({});
    const [searchParams, setSearchParams] = useSearchParams({page_number: 1});
    const [email, setemail] = useState('');
    const [fistLoading, setFirstLoading] = useState(false)
    const [emptyScreenMessage, setEmptyScreenMessage] = useState('');
    const [FilterData, setFilterData] = useState({});
    const [FilterCheckbox, setFilterCheckBox] = useState({})
    const [filterCount, setFilterCount] = useState(0)
    const {reloadFY, setReloadFY} = useContext(GlobalContext);

    /**
     * The function sets the loading state to true and updates the search parameters with a page number
     * of 1.
     */
    const handleLoadData = () => {
        setLoading(true);
        setSearchParams({ page_number:  1 })
        const selectedFY = JSON.parse(localStorage.getItem('FY_details'));
        setSearchParams({ financial_year:  encodeURIComponent(selectedFY.name), filter: true })
    }
    /* `const getBranch` is a function that is defined using the `useCallback` hook. It is used
    to fetch the list of admin users from the server and update the state with the response data.
    The function uses the `dispatch` function from the `useDispatch` hook to dispatch an action
    creator called `AdminUser` with the `searchParams` as an argument. The `AdminUser` action
    creator is responsible for making an API call to fetch the list of admin users from the server.
    Once the API call is successful, the function checks if the `success_status` property of the
    response data is true. If it is true, the function does nothing. If it is false, the function
    sets an error message using the `setToastErrorMessage` function. The `getBranch` function
    is memoized using the `useCallback` hook with the `location` value as a dependency, which means
    that it will only be redefined if the `location` value changes. */
    const getPayrollUsers = useCallback(async () => {
        setLoading(true)
        try {
            const branch_id = await GetBranchId()
            const financialYear = searchParams?.get('financial_year');
            if (financialYear) {
                searchParams.set('financial_year', financialYear.split('(')[0].trim());
            }
            else
            {
                const selectedFY = JSON.parse(localStorage.getItem('FY_details'));
                searchParams.set('financial_year', selectedFY.name);
                searchParams.set('filter', true);
            }
            dispatch(
                PayrollData(`payroll?branch_id=${branch_id}&${searchParams.toString()}`)).then((response) => {
                if (response?.payload?.data.status===200) {
                    if(response.payload.data.data.total_count === 0 && searchParams.get('filter')===null) {
                        setFirstLoading(true);
                    } else {
                        setEmptyScreenMessage("No matching records found")  
                    }
                    if(Math.ceil(response?.payload?.data?.data.total_count / 10) <  Number(searchParams.get('page_number'))) {
                        if(response?.payload?.data?.data.total_count !== 0) {
                            // setToastErrorMessage('Something went wrong. Please try again')
                            setEmptyScreenMessage("No data found");
                        } else {
                            setEmptyScreenMessage("No matching records found.")
                        }
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                    setEmptyScreenMessage("No data found.");
                    // setToastErrorMessage('Something went wrong. Please try again')
                }
            })
            if(email===''){
                setemail(localStorage.getItem('email'))
            }
            // setsearchFieldDebounce(searchParams.get('search') !== null ? searchParams.get('search') : '')
        } catch (error) {
            handleLoadData()
            console.error("error33", error);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
        }
    }, [location]);

    useEffect(() => {
        if (reloadFY) {
            // Reload the page
            window.location.reload();
            setReloadFY(false);
        }
    }, [reloadFY]);

    /**
     * This function handles the click event of a page number and updates the search parameters with
     * the selected page number.
     */
    const handleOnClickPageNumber = (pageNum) => {
        setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum.selected + 1 })
    }

    /**
     * This function updates search parameters with a new key-value pair and sets the page number to 1.
     */
    const handleSearchParams = (key, value) => {
        // setLoading(true);
        // setEmptyScreenMessage("We couldn't find anything that matched your search")
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if(key === 'search') {params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params})
    }

    /* `useEffect(() => { getBranch(); }, [getBranch]);` is a hook that is used to run
    the `getBranch` function whenever the `getBranch` function changes. In this case,
    the `getBranch` function is memoized using the `useCallback` hook, which means that it
    will only be redefined if the `location` value changes. Therefore, the `useEffect` hook will run
    the `getBranch` function whenever the `location` value changes. This hook is used to
    fetch the list of admin users from the server and update the `tableData` state with the response
    data. */
    useEffect(() => {
        //getBranch();
        getPayrollUsers();
    }, [searchParams]);

    useEffect(()=>{
        getFilterData();
    },[])

    /**
     * The function `getCount` counts the number of non-empty values in the `FilterCheckbox` object and
     * updates the `filterCount` state variable accordingly.
     */
    const getCount = (type) => {
        let count = 0
        Object.keys(FilterCheckbox).map((item) =>  {
            if(FilterCheckbox[item] &&FilterCheckbox[item]?.length !== 0 && item!="end_date") {
                count += 1
            }
        })
        if(type) {
            setFilterCount(count)

        } else {
            setFilterCount(0)
        }
    }

    /**
   * The function `handleApplyFilter` updates the search parameters based on the selected filter
   * options and triggers a count update.
   */
    const handleApplyFilter = (type) => {
        setEmptyScreenMessage("It seems there's nothing to display here.");
        let params = Object.fromEntries(searchParams);
        if(type) {
            let flag = true;
            params["filter"] = true
            params.page_number = 1
            Object.keys(FilterCheckbox).map((item) => {
                let val = ""
                // Handle splitting of financial_year
                if (item === "financial_year") {
                    val = FilterCheckbox[item].map(fy => fy.split('(')[0].trim());
                    params[item] = val;
                } else {
                    params[item] = FilterCheckbox[item];
                }                
                setSearchParams({ ...params})
                flag=false
                if(flag) {
                    delete params.filter
                    setSearchParams({ ...params})  
                }
            })
        } else {
            delete params.filter
            Object.keys(FilterCheckbox).map((item) => {
                delete params[item]
            })
            delete params.start_date
            delete params.end_date
            setSearchParams({ ...params})
            setFilterCheckBox([])
        }
        getCount(type)
    }


    /**
     * The function `getFilterData` retrieves financial year data based on the branch ID and sets the
     * filter data with the retrieved information.
     */
    const getFilterData = async() => {
        const branch_id = await GetBranchId();
        let finacial_year_data = []
        const res = await dataService.GetAPI(`financial-years?branch_id=${branch_id}&filter=true&status=ongoing,open,closed&sort=start_date%2Bdesc`, true);
        res?.data?.data?.financial_years.map((item)=>{
            finacial_year_data.push(
                `${item?.name} (${item?.status?.charAt(0)?.toUpperCase() + item?.status?.slice(1)})`
            );
        })
        setFilterData({financial_year: finacial_year_data})
    }

    return (
        <>
            <CardHeader noPadding>
                <TopBarWithShadow 
                    Tittle={'Payroll'}
                    AddButton={true}
                    AddButtonName={'Upload Payroll'}
                    SearchValue={!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || ''}
                    handleOnClickSearch={handleSearchParams}
                    ApplyFilter={true}
                    FilterData={FilterData}
                    handleApplyFilter={handleApplyFilter}
                    FilterCheckbox={FilterCheckbox}
                    setFilterCheckBox={setFilterCheckBox}
                    filterCount={filterCount}
                    searchParams={searchParams}
                    firstFilter={"financial_year"}
                    radioButton
                    handleSidePopupClick={()=>{setIsSidePopup(true)}}
                    filterFromPage={'Payroll'}
                />
                <div className='mainDataCntnrListDiv scrollBlue_thick'>
                    {loading ? <ItemShimmer classkey={"mt-[32px]"}/> : <>
                        <Table
                            pageNumber={Number(searchParams.get('page_number')) || 1}
                            handleOnClickSort={handleSearchParams}
                            sortValue={searchParams.get('sort') || ''}
                            setConfirmationState={setConfirmationState}
                            email={email}
                            setLoading={setLoading}
                            getListData={getPayrollUsers}
                            setToastErrorMessage={setToastErrorMessage}
                            searchParams={searchParams}
                            
                        />
                        {(List.total_count > 10) && <Pagination
                            TotalCount={List.total_count}
                            totalPageNumber={Math.ceil(List.total_count / 10)}
                            selectedPageNumber={Number(searchParams.get('page_number')) || 1}
                            handleOnClickPageNumber={handleOnClickPageNumber}
                        />}
                    </>
                    }
                </div>
                {toastErrorMessage!=='' &&<Toast 
                    message={toastErrorMessage}
                    type="error"
                    setToastmessage={setToastErrorMessage} />}

            </CardHeader>
            {isSidePopup && <SidePopup 
                handleSidePopupClick={() => setIsSidePopup(false)}
                setIsSidePopup={setIsSidePopup}
                getPayrollUsers={getPayrollUsers}
            />}
        </>
    )
}
